import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import CommonRuleSummary from '../edit/rules/CommonRuleSummary';
import { EventSections } from '../../../lib/events/EventLogger';

interface props {
  item: SmartSendItemApiModel;
}

export default function SmartSendItemRules(props: props) {
  return (
    <div style={{ minWidth: '450px', maxWidth: '550px' }}>
      <CommonRuleSummary
        limitToSelection={true}
        item={props.item}
        sections={[EventSections.SmartSend, EventSections.SmartSendItem, EventSections.QuickActions, 'rules']}
      />
    </div>
  );
}
